import { environment } from '@environments/environment';
/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  DeepNonNullable
} from '@orval/core';

import {
  Observable
} from 'rxjs';

import type {
  AcceptWorkspaceInvitationApiResponse,
  AcceptWorkspaceInvitationRequest,
  AddContactGroupMembersApiResponse,
  AddContactGroupMembersRequest,
  AiGenerateApiResponse,
  AiGenerateRequest,
  BuiltFormDto,
  CheckFormSlugApiResponse,
  CheckFormSlugAvailabilityParams,
  CheckWorkspaceSlugApiResponse,
  CheckWorkspaceSlugAvailabilityParams,
  ConfirmPaymentApiResponse,
  ConfirmPaymentRequest,
  CreateCompanyApiResponse,
  CreateCompanyRequest,
  CreateContactApiResponse,
  CreateContactGroupApiResponse,
  CreateContactGroupRequest,
  CreateContactRequest,
  CreateContactsApiResponse,
  CreateContactsRequest,
  CreateDataLibraryCollectionApiResponse,
  CreateDataLibraryCollectionItemApiResponse,
  CreateDataLibraryCollectionItemRequest,
  CreateDataLibraryCollectionRequest,
  CreateDataLibraryVariableApiResponse,
  CreateDataLibraryVariableRequest,
  CreateFormApiResponse,
  CreateFormRequest,
  CreatePublicFormSubmissionApiResponse,
  CreatePublicFormSubmissionRequest,
  CreateWorkspaceApiResponse,
  CreateWorkspaceInvitationsApiResponse,
  CreateWorkspaceInvitationsRequest,
  CreateWorkspaceRequest,
  DeleteContactApiResponse,
  DeleteContactGroupApiResponse,
  DeleteDataLibraryCollectionApiResponse,
  DeleteDataLibraryCollectionItemApiResponse,
  DeleteDataLibraryVariableApiResponse,
  DeleteDataLibraryVariableParams,
  ExchangeTicketApiResponse,
  ExchangeTicketRequest,
  GetAvailablePlansApiResponse,
  GetContactApiResponse,
  GetContactGroupApiResponse,
  GetDataLibraryCollectionApiResponse,
  GetFormApiResponse,
  GetFormDetailsParams,
  GetPublicFormDraftApiResponse,
  ListContactGroupMembersApiResponse,
  ListContactGroupMembersParams,
  ListContactGroupsApiResponse,
  ListContactGroupsParams,
  ListContactsApiResponse,
  ListContactsParams,
  ListDataLibraryApiResponse,
  ListDataLibraryCollectionItemsApiResponse,
  ListDataLibraryCollectionItemsParams,
  ListDataLibraryParams,
  ListDataLibraryVariableUsagesApiResponse,
  ListFormsApiResponse,
  ListMyWorkspacesApiResponse,
  ListPublicFormFieldOptionsParams,
  ListSystemVariablesApiResponse,
  ListSystemVariablesParams,
  ListWorkspaceInvitationsApiResponse,
  ListWorkspaceMembersApiResponse,
  LoginLocalApiResponse,
  LoginLocalRequest,
  OnboardingSurveyApiResponse,
  PatchContactApiResponse,
  PatchContactGroupApiResponse,
  PatchContactGroupRequest,
  PatchContactRequest,
  PatchDataLibraryCollectionApiResponse,
  PatchDataLibraryCollectionItemApiResponse,
  PatchDataLibraryCollectionItemRequest,
  PatchDataLibraryCollectionRequest,
  PatchDataLibraryVariableApiResponse,
  PatchDataLibraryVariableRequest,
  PreviewWorkspaceInvitationApiResponse,
  PreviewWorkspaceInvitationParams,
  PublicFieldOptionsApiResponse,
  PublishFormApiResponse,
  PublishFormRequest,
  PutPublicFormDraftApiResponse,
  PutPublicFormDraftRequest,
  RedirectToGoogleAuthParams,
  RemoveContactGroupMemberApiResponse,
  ResolvePublicFormApiResponse,
  SaveFormDefinitionApiResponse,
  SignupGoogleRequest,
  SignupLocalApiResponse,
  SignupLocalRequest,
  StartTrialApiResponse,
  SwitchWorkspaceApiResponse,
  SwitchWorkspaceRequest,
  UnlockPublicFormApiResponse,
  UnlockPublicFormRequest,
  UpdateOnboardingHeardAboutRequest,
  UpdateOnboardingIndustryRequest,
  UpdateOnboardingPlannedUseCasesRequest,
  UpdateOnboardingTeamSizeRequest
} from '../../models';



interface HttpClientOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  context?: HttpContext;
  params?:
        | HttpParams
        | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  reportProgress?: boolean;
  withCredentials?: boolean;
  credentials?: RequestCredentials;
  keepalive?: boolean;
  priority?: RequestPriority;
  cache?: RequestCache;
  mode?: RequestMode;
  redirect?: RequestRedirect;
  referrer?: string;
  integrity?: string;
  transferCache?: {includeHeaders?: string[]} | boolean;
  timeout?: number;
}



@Injectable({ providedIn: 'root' })
export class WorkspaceAPIService {
  private readonly http = inject(HttpClient);
/**
 * Issues a new access token scoped to the selected workspace after validating membership.
 * @summary Switch active workspace session
 */
 switchWorkspace<TData = SwitchWorkspaceApiResponse>(switchWorkspaceRequest: SwitchWorkspaceRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 switchWorkspace<TData = SwitchWorkspaceApiResponse>(switchWorkspaceRequest: SwitchWorkspaceRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 switchWorkspace<TData = SwitchWorkspaceApiResponse>(switchWorkspaceRequest: SwitchWorkspaceRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  switchWorkspace<TData = SwitchWorkspaceApiResponse>(
    switchWorkspaceRequest: SwitchWorkspaceRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/workspaces/switch`,
      switchWorkspaceRequest,options
    );
  }

/**
 * Saves the workspace owner team size answer for the post-signup onboarding survey.
 * @summary Update onboarding team size
 */
 updateOnboardingTeamSize<TData = OnboardingSurveyApiResponse>(updateOnboardingTeamSizeRequest: UpdateOnboardingTeamSizeRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 updateOnboardingTeamSize<TData = OnboardingSurveyApiResponse>(updateOnboardingTeamSizeRequest: UpdateOnboardingTeamSizeRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 updateOnboardingTeamSize<TData = OnboardingSurveyApiResponse>(updateOnboardingTeamSizeRequest: UpdateOnboardingTeamSizeRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  updateOnboardingTeamSize<TData = OnboardingSurveyApiResponse>(
    updateOnboardingTeamSizeRequest: UpdateOnboardingTeamSizeRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/companies/onboarding/team-size`,
      updateOnboardingTeamSizeRequest,options
    );
  }

/**
 * Saves the workspace owner planned use cases (multi-select labels) for the post-signup onboarding survey.
 * @summary Update onboarding planned use cases
 */
 updateOnboardingPlannedUseCases<TData = OnboardingSurveyApiResponse>(updateOnboardingPlannedUseCasesRequest: UpdateOnboardingPlannedUseCasesRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 updateOnboardingPlannedUseCases<TData = OnboardingSurveyApiResponse>(updateOnboardingPlannedUseCasesRequest: UpdateOnboardingPlannedUseCasesRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 updateOnboardingPlannedUseCases<TData = OnboardingSurveyApiResponse>(updateOnboardingPlannedUseCasesRequest: UpdateOnboardingPlannedUseCasesRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  updateOnboardingPlannedUseCases<TData = OnboardingSurveyApiResponse>(
    updateOnboardingPlannedUseCasesRequest: UpdateOnboardingPlannedUseCasesRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/companies/onboarding/planned-use-cases`,
      updateOnboardingPlannedUseCasesRequest,options
    );
  }

/**
 * Saves the workspace owner industry answer for the post-signup onboarding survey.
 * @summary Update onboarding industry
 */
 updateOnboardingIndustry<TData = OnboardingSurveyApiResponse>(updateOnboardingIndustryRequest: UpdateOnboardingIndustryRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 updateOnboardingIndustry<TData = OnboardingSurveyApiResponse>(updateOnboardingIndustryRequest: UpdateOnboardingIndustryRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 updateOnboardingIndustry<TData = OnboardingSurveyApiResponse>(updateOnboardingIndustryRequest: UpdateOnboardingIndustryRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  updateOnboardingIndustry<TData = OnboardingSurveyApiResponse>(
    updateOnboardingIndustryRequest: UpdateOnboardingIndustryRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/companies/onboarding/industry`,
      updateOnboardingIndustryRequest,options
    );
  }

/**
 * Saves the workspace owner referral source answer for the post-signup onboarding survey.
 * @summary Update how user heard about FormOps
 */
 updateOnboardingHeardAbout<TData = OnboardingSurveyApiResponse>(updateOnboardingHeardAboutRequest: UpdateOnboardingHeardAboutRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 updateOnboardingHeardAbout<TData = OnboardingSurveyApiResponse>(updateOnboardingHeardAboutRequest: UpdateOnboardingHeardAboutRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 updateOnboardingHeardAbout<TData = OnboardingSurveyApiResponse>(updateOnboardingHeardAboutRequest: UpdateOnboardingHeardAboutRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  updateOnboardingHeardAbout<TData = OnboardingSurveyApiResponse>(
    updateOnboardingHeardAboutRequest: UpdateOnboardingHeardAboutRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/companies/onboarding/heard-about`,
      updateOnboardingHeardAboutRequest,options
    );
  }

/**
 * Marks the workspace onboarding survey as skipped so login and routing can skip the survey flow.
 * @summary Skip onboarding survey
 */
 skipOnboardingSurvey<TData = OnboardingSurveyApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 skipOnboardingSurvey<TData = OnboardingSurveyApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 skipOnboardingSurvey<TData = OnboardingSurveyApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  skipOnboardingSurvey<TData = OnboardingSurveyApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/companies/onboarding/skip`,undefined,options
    );
  }

/**
 * Returns all active workspaces the authenticated user can access.
 * @summary List my workspaces
 */
 listMyWorkspaces<TData = ListMyWorkspacesApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listMyWorkspaces<TData = ListMyWorkspacesApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listMyWorkspaces<TData = ListMyWorkspacesApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listMyWorkspaces<TData = ListMyWorkspacesApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/workspaces/mine`,options
    );
  }

/**
 * Returns minimal invitation details for the accept page. Public endpoint.
 * @summary Preview a workspace invitation
 */
 previewWorkspaceInvitation<TData = PreviewWorkspaceInvitationApiResponse>(params: DeepNonNullable<PreviewWorkspaceInvitationParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 previewWorkspaceInvitation<TData = PreviewWorkspaceInvitationApiResponse>(params: DeepNonNullable<PreviewWorkspaceInvitationParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 previewWorkspaceInvitation<TData = PreviewWorkspaceInvitationApiResponse>(params: DeepNonNullable<PreviewWorkspaceInvitationParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  previewWorkspaceInvitation<TData = PreviewWorkspaceInvitationApiResponse>(
    params: DeepNonNullable<PreviewWorkspaceInvitationParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/workspaces/invitations/preview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns active members of the current workspace.
 * @summary List workspace members
 */
 listWorkspaceMembers<TData = ListWorkspaceMembersApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listWorkspaceMembers<TData = ListWorkspaceMembersApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listWorkspaceMembers<TData = ListWorkspaceMembersApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listWorkspaceMembers<TData = ListWorkspaceMembersApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/workspaces/members`,options
    );
  }

/**
 * Returns pending invitations for the current workspace. Raw tokens are not included.
 * @summary List pending workspace invitations
 */
 listWorkspaceInvitations<TData = ListWorkspaceInvitationsApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listWorkspaceInvitations<TData = ListWorkspaceInvitationsApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listWorkspaceInvitations<TData = ListWorkspaceInvitationsApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listWorkspaceInvitations<TData = ListWorkspaceInvitationsApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/workspaces/invitations`,options
    );
  }

/**
 * Batch-invites multiple emails to the current workspace with a shared role. Returns shareable invite links.
 * @summary Create workspace invitations
 */
 createWorkspaceInvitations<TData = CreateWorkspaceInvitationsApiResponse>(createWorkspaceInvitationsRequest: CreateWorkspaceInvitationsRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createWorkspaceInvitations<TData = CreateWorkspaceInvitationsApiResponse>(createWorkspaceInvitationsRequest: CreateWorkspaceInvitationsRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createWorkspaceInvitations<TData = CreateWorkspaceInvitationsApiResponse>(createWorkspaceInvitationsRequest: CreateWorkspaceInvitationsRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createWorkspaceInvitations<TData = CreateWorkspaceInvitationsApiResponse>(
    createWorkspaceInvitationsRequest: CreateWorkspaceInvitationsRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/workspaces/invitations`,
      createWorkspaceInvitationsRequest,options
    );
  }

/**
 * Accepts a pending invitation using the opaque token. The authenticated user email must match the invite.
 * @summary Accept a workspace invitation
 */
 acceptWorkspaceInvitation<TData = AcceptWorkspaceInvitationApiResponse>(acceptWorkspaceInvitationRequest: AcceptWorkspaceInvitationRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 acceptWorkspaceInvitation<TData = AcceptWorkspaceInvitationApiResponse>(acceptWorkspaceInvitationRequest: AcceptWorkspaceInvitationRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 acceptWorkspaceInvitation<TData = AcceptWorkspaceInvitationApiResponse>(acceptWorkspaceInvitationRequest: AcceptWorkspaceInvitationRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  acceptWorkspaceInvitation<TData = AcceptWorkspaceInvitationApiResponse>(
    acceptWorkspaceInvitationRequest: AcceptWorkspaceInvitationRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/workspaces/invitations/accept`,
      acceptWorkspaceInvitationRequest,options
    );
  }

/**
 * Creates an additional workspace under the authenticated user's company (no new subscription). Returns tokens scoped to the new workspace.
 * @summary Create a workspace
 */
 createWorkspace<TData = CreateWorkspaceApiResponse>(createWorkspaceRequest: CreateWorkspaceRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createWorkspace<TData = CreateWorkspaceApiResponse>(createWorkspaceRequest: CreateWorkspaceRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createWorkspace<TData = CreateWorkspaceApiResponse>(createWorkspaceRequest: CreateWorkspaceRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createWorkspace<TData = CreateWorkspaceApiResponse>(
    createWorkspaceRequest: CreateWorkspaceRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/workspaces`,
      createWorkspaceRequest,options
    );
  }

/**
 * Checks whether a workspace slug is valid and available. Requires authentication.
 * @summary Check workspace slug availability
 */
 checkWorkspaceSlugAvailability<TData = CheckWorkspaceSlugApiResponse>(params: DeepNonNullable<CheckWorkspaceSlugAvailabilityParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 checkWorkspaceSlugAvailability<TData = CheckWorkspaceSlugApiResponse>(params: DeepNonNullable<CheckWorkspaceSlugAvailabilityParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 checkWorkspaceSlugAvailability<TData = CheckWorkspaceSlugApiResponse>(params: DeepNonNullable<CheckWorkspaceSlugAvailabilityParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  checkWorkspaceSlugAvailability<TData = CheckWorkspaceSlugApiResponse>(
    params: DeepNonNullable<CheckWorkspaceSlugAvailabilityParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/workspaces/slug-availability`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns built-in system variable keys that can be bound to form fields. Optional filters by valueType and resolve phase.
 * @summary List system variables
 */
 listSystemVariables<TData = ListSystemVariablesApiResponse>(params?: DeepNonNullable<ListSystemVariablesParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listSystemVariables<TData = ListSystemVariablesApiResponse>(params?: DeepNonNullable<ListSystemVariablesParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listSystemVariables<TData = ListSystemVariablesApiResponse>(params?: DeepNonNullable<ListSystemVariablesParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listSystemVariables<TData = ListSystemVariablesApiResponse>(
    params?: DeepNonNullable<ListSystemVariablesParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/system-variables`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Activates a free trial for the workspace subscription in the JWT context. Only the workspace owner can call this endpoint. The subscription must be PENDING_PAYMENT and the plan must offer trial days.
 * @summary Start free trial
 */
 startSubscriptionTrial<TData = StartTrialApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 startSubscriptionTrial<TData = StartTrialApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 startSubscriptionTrial<TData = StartTrialApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  startSubscriptionTrial<TData = StartTrialApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/subscriptions/start-trial`,undefined,options
    );
  }

/**
 * Mock payment confirmation endpoint. Activates a subscription that is in PENDING_PAYMENT status. Requires a valid Bearer access token. Only the workspace owner can confirm payment for the workspace in the JWT context.
 * @summary Confirm subscription payment
 */
 confirmSubscriptionPayment<TData = ConfirmPaymentApiResponse>(confirmPaymentRequest: ConfirmPaymentRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 confirmSubscriptionPayment<TData = ConfirmPaymentApiResponse>(confirmPaymentRequest: ConfirmPaymentRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 confirmSubscriptionPayment<TData = ConfirmPaymentApiResponse>(confirmPaymentRequest: ConfirmPaymentRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  confirmSubscriptionPayment<TData = ConfirmPaymentApiResponse>(
    confirmPaymentRequest: ConfirmPaymentRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/subscriptions/confirm-payment`,
      confirmPaymentRequest,options
    );
  }

/**
 * Verifies the access password and returns a short-lived form access token.
 * @summary Unlock a password-protected published form
 */
 unlockPublicForm<TData = UnlockPublicFormApiResponse>(workspaceSlug: string,
    formSlug: string,
    unlockPublicFormRequest: UnlockPublicFormRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 unlockPublicForm<TData = UnlockPublicFormApiResponse>(workspaceSlug: string,
    formSlug: string,
    unlockPublicFormRequest: UnlockPublicFormRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 unlockPublicForm<TData = UnlockPublicFormApiResponse>(workspaceSlug: string,
    formSlug: string,
    unlockPublicFormRequest: UnlockPublicFormRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  unlockPublicForm<TData = UnlockPublicFormApiResponse>(
    workspaceSlug: string,
    formSlug: string,
    unlockPublicFormRequest: UnlockPublicFormRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/api/public/forms/${workspaceSlug}/${formSlug}/unlock`,
      unlockPublicFormRequest,options
    );
  }

/**
 * Looks up a globally unique form shortCode and redirects (302) to the long published form URL.
 * @summary Resolve a form short code to the published form URL
 */
 resolveFormShortLink<TData = unknown>(code: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 resolveFormShortLink<TData = unknown>(code: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 resolveFormShortLink<TData = unknown>(code: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  resolveFormShortLink<TData = unknown>(
    code: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/public/short-links/${code}`,options
    );
  }

/**
 * Returns access state for a published form by workspace and form slug. Handles schedule windows, password protection, and specific-people visibility.
 * @summary Resolve a published form for public fill access
 */
 resolvePublicForm<TData = ResolvePublicFormApiResponse>(workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 resolvePublicForm<TData = ResolvePublicFormApiResponse>(workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 resolvePublicForm<TData = ResolvePublicFormApiResponse>(workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  resolvePublicForm<TData = ResolvePublicFormApiResponse>(
    workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/public/forms/${workspaceSlug}/${formSlug}`,options
    );
  }

/**
 * @summary Get the active draft for the current respondent or draft key
 */
 getPublicFormDraft<TData = GetPublicFormDraftApiResponse>(workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getPublicFormDraft<TData = GetPublicFormDraftApiResponse>(workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getPublicFormDraft<TData = GetPublicFormDraftApiResponse>(workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getPublicFormDraft<TData = GetPublicFormDraftApiResponse>(
    workspaceSlug: string,
    formSlug: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/public/forms/${workspaceSlug}/${formSlug}/submissions/draft`,options
    );
  }

/**
 * @summary Create or update a server-side draft (lenient validation)
 */
 putPublicFormDraft<TData = PutPublicFormDraftApiResponse>(workspaceSlug: string,
    formSlug: string,
    putPublicFormDraftRequest: PutPublicFormDraftRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 putPublicFormDraft<TData = PutPublicFormDraftApiResponse>(workspaceSlug: string,
    formSlug: string,
    putPublicFormDraftRequest: PutPublicFormDraftRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 putPublicFormDraft<TData = PutPublicFormDraftApiResponse>(workspaceSlug: string,
    formSlug: string,
    putPublicFormDraftRequest: PutPublicFormDraftRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  putPublicFormDraft<TData = PutPublicFormDraftApiResponse>(
    workspaceSlug: string,
    formSlug: string,
    putPublicFormDraftRequest: PutPublicFormDraftRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.put<TData>(
      `${environment.baseUrl}/api/public/forms/${workspaceSlug}/${formSlug}/submissions/draft`,
      putPublicFormDraftRequest,options
    );
  }

/**
 * @summary Finalize a form submission (strict validation, caps, metering)
 */
 createPublicFormSubmission<TData = CreatePublicFormSubmissionApiResponse>(workspaceSlug: string,
    formSlug: string,
    createPublicFormSubmissionRequest: CreatePublicFormSubmissionRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createPublicFormSubmission<TData = CreatePublicFormSubmissionApiResponse>(workspaceSlug: string,
    formSlug: string,
    createPublicFormSubmissionRequest: CreatePublicFormSubmissionRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createPublicFormSubmission<TData = CreatePublicFormSubmissionApiResponse>(workspaceSlug: string,
    formSlug: string,
    createPublicFormSubmissionRequest: CreatePublicFormSubmissionRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createPublicFormSubmission<TData = CreatePublicFormSubmissionApiResponse>(
    workspaceSlug: string,
    formSlug: string,
    createPublicFormSubmissionRequest: CreatePublicFormSubmissionRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/api/public/forms/${workspaceSlug}/${formSlug}/submissions`,
      createPublicFormSubmissionRequest,options
    );
  }

/**
 * @summary List options for a public form field (static or data library)
 */
 listPublicFormFieldOptions<TData = PublicFieldOptionsApiResponse>(workspaceSlug: string,
    formSlug: string,
    fieldId: string,
    params?: DeepNonNullable<ListPublicFormFieldOptionsParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listPublicFormFieldOptions<TData = PublicFieldOptionsApiResponse>(workspaceSlug: string,
    formSlug: string,
    fieldId: string,
    params?: DeepNonNullable<ListPublicFormFieldOptionsParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listPublicFormFieldOptions<TData = PublicFieldOptionsApiResponse>(workspaceSlug: string,
    formSlug: string,
    fieldId: string,
    params?: DeepNonNullable<ListPublicFormFieldOptionsParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listPublicFormFieldOptions<TData = PublicFieldOptionsApiResponse>(
    workspaceSlug: string,
    formSlug: string,
    fieldId: string,
    params?: DeepNonNullable<ListPublicFormFieldOptionsParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/public/forms/${workspaceSlug}/${formSlug}/fields/${fieldId}/options`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns all active plans for landing page pricing display. Pricing is based on country detected from request headers (cf-ipcountry, X-Country-Code) with USD as fallback.
 * @summary Get available plans
 */
 getAvailablePlans<TData = GetAvailablePlansApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getAvailablePlans<TData = GetAvailablePlansApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getAvailablePlans<TData = GetAvailablePlansApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getAvailablePlans<TData = GetAvailablePlansApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/plans/available`,options
    );
  }

/**
 * Creates or overwrites the current draft form version for the given slug.
 * @summary Save form definition
 */
 saveFormDefinition<TData = SaveFormDefinitionApiResponse>(slug: string,
    builtFormDto: BuiltFormDto, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 saveFormDefinition<TData = SaveFormDefinitionApiResponse>(slug: string,
    builtFormDto: BuiltFormDto, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 saveFormDefinition<TData = SaveFormDefinitionApiResponse>(slug: string,
    builtFormDto: BuiltFormDto, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  saveFormDefinition<TData = SaveFormDefinitionApiResponse>(
    slug: string,
    builtFormDto: BuiltFormDto, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.put<TData>(
      `${environment.baseUrl}/forms/${slug}/definition`,
      builtFormDto,options
    );
  }

/**
 * Sets the form status to published and upserts publish settings. The form slug is immutable after create.
 * @summary Publish form
 */
 publishForm<TData = PublishFormApiResponse>(slug: string,
    publishFormRequest: PublishFormRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 publishForm<TData = PublishFormApiResponse>(slug: string,
    publishFormRequest: PublishFormRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 publishForm<TData = PublishFormApiResponse>(slug: string,
    publishFormRequest: PublishFormRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  publishForm<TData = PublishFormApiResponse>(
    slug: string,
    publishFormRequest: PublishFormRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/forms/${slug}/publish`,
      publishFormRequest,options
    );
  }

/**
 * Returns form headers for the active workspace, newest updated first.
 * @summary List forms
 */
 listForms<TData = ListFormsApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listForms<TData = ListFormsApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listForms<TData = ListFormsApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listForms<TData = ListFormsApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/forms`,options
    );
  }

/**
 * Creates a draft form header in the active workspace with a name and category type.
 * @summary Create a form
 */
 createForm<TData = CreateFormApiResponse>(createFormRequest: CreateFormRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createForm<TData = CreateFormApiResponse>(createFormRequest: CreateFormRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createForm<TData = CreateFormApiResponse>(createFormRequest: CreateFormRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createForm<TData = CreateFormApiResponse>(
    createFormRequest: CreateFormRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/forms`,
      createFormRequest,options
    );
  }

/**
 * Returns the form header, current definition, publish settings, and share fields for the active workspace.
 * @summary Get form details by slug
 */
 getFormDetails<TData = GetFormApiResponse>(params: DeepNonNullable<GetFormDetailsParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getFormDetails<TData = GetFormApiResponse>(params: DeepNonNullable<GetFormDetailsParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getFormDetails<TData = GetFormApiResponse>(params: DeepNonNullable<GetFormDetailsParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getFormDetails<TData = GetFormApiResponse>(
    params: DeepNonNullable<GetFormDetailsParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/forms/details`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Checks whether a form slug is valid and available in the active workspace.
 * @summary Check form slug availability
 */
 checkFormSlugAvailability<TData = CheckFormSlugApiResponse>(params: DeepNonNullable<CheckFormSlugAvailabilityParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 checkFormSlugAvailability<TData = CheckFormSlugApiResponse>(params: DeepNonNullable<CheckFormSlugAvailabilityParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 checkFormSlugAvailability<TData = CheckFormSlugApiResponse>(params: DeepNonNullable<CheckFormSlugAvailabilityParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  checkFormSlugAvailability<TData = CheckFormSlugApiResponse>(
    params: DeepNonNullable<CheckFormSlugAvailabilityParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/forms/slug-availability`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new form definition or updates an existing one using OpenAI, constrained to the provided component catalog and page settings.
 * @summary Generate or update a form with AI
 */
 generateFormWithAi<TData = AiGenerateApiResponse>(aiGenerateRequest: AiGenerateRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 generateFormWithAi<TData = AiGenerateApiResponse>(aiGenerateRequest: AiGenerateRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 generateFormWithAi<TData = AiGenerateApiResponse>(aiGenerateRequest: AiGenerateRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  generateFormWithAi<TData = AiGenerateApiResponse>(
    aiGenerateRequest: AiGenerateRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/forms/ai/generate`,
      aiGenerateRequest,options
    );
  }

/**
 * Updates the scalar value of a variable in the active workspace. The value must match the existing valueType.
 * @summary Update a data library variable value
 */
 patchDataLibraryVariable<TData = PatchDataLibraryVariableApiResponse>(id: string,
    patchDataLibraryVariableRequest: PatchDataLibraryVariableRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 patchDataLibraryVariable<TData = PatchDataLibraryVariableApiResponse>(id: string,
    patchDataLibraryVariableRequest: PatchDataLibraryVariableRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 patchDataLibraryVariable<TData = PatchDataLibraryVariableApiResponse>(id: string,
    patchDataLibraryVariableRequest: PatchDataLibraryVariableRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  patchDataLibraryVariable<TData = PatchDataLibraryVariableApiResponse>(
    id: string,
    patchDataLibraryVariableRequest: PatchDataLibraryVariableRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/data-library/variables/${id}`,
      patchDataLibraryVariableRequest,options
    );
  }

/**
 * Permanently deletes a variable from the active workspace. When the variable is in use, mode=retain unwraps linked field defaults to static values; mode=remove clears those defaults. Usage rows are removed with the variable.
 * @summary Delete a data library variable
 */
 deleteDataLibraryVariable<TData = DeleteDataLibraryVariableApiResponse>(id: string,
    params?: DeepNonNullable<DeleteDataLibraryVariableParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 deleteDataLibraryVariable<TData = DeleteDataLibraryVariableApiResponse>(id: string,
    params?: DeepNonNullable<DeleteDataLibraryVariableParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 deleteDataLibraryVariable<TData = DeleteDataLibraryVariableApiResponse>(id: string,
    params?: DeepNonNullable<DeleteDataLibraryVariableParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  deleteDataLibraryVariable<TData = DeleteDataLibraryVariableApiResponse>(
    id: string,
    params?: DeepNonNullable<DeleteDataLibraryVariableParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.delete<TData>(
      `${environment.baseUrl}/data-library/variables/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates values for a row in a data library collection.
 * @summary Update a collection row
 */
 patchDataLibraryCollectionItem<TData = PatchDataLibraryCollectionItemApiResponse>(id: string,
    itemId: string,
    patchDataLibraryCollectionItemRequest: PatchDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 patchDataLibraryCollectionItem<TData = PatchDataLibraryCollectionItemApiResponse>(id: string,
    itemId: string,
    patchDataLibraryCollectionItemRequest: PatchDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 patchDataLibraryCollectionItem<TData = PatchDataLibraryCollectionItemApiResponse>(id: string,
    itemId: string,
    patchDataLibraryCollectionItemRequest: PatchDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  patchDataLibraryCollectionItem<TData = PatchDataLibraryCollectionItemApiResponse>(
    id: string,
    itemId: string,
    patchDataLibraryCollectionItemRequest: PatchDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/data-library/collections/${id}/items/${itemId}`,
      patchDataLibraryCollectionItemRequest,options
    );
  }

/**
 * Soft-deletes a row from a data library collection.
 * @summary Delete a collection row
 */
 deleteDataLibraryCollectionItem<TData = DeleteDataLibraryCollectionItemApiResponse>(id: string,
    itemId: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 deleteDataLibraryCollectionItem<TData = DeleteDataLibraryCollectionItemApiResponse>(id: string,
    itemId: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 deleteDataLibraryCollectionItem<TData = DeleteDataLibraryCollectionItemApiResponse>(id: string,
    itemId: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  deleteDataLibraryCollectionItem<TData = DeleteDataLibraryCollectionItemApiResponse>(
    id: string,
    itemId: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.delete<TData>(
      `${environment.baseUrl}/data-library/collections/${id}/items/${itemId}`,options
    );
  }

/**
 * Updates collection name and/or column definitions. Removed columns are stripped from existing rows.
 * @summary Update a data library collection
 */
 patchDataLibraryCollection<TData = PatchDataLibraryCollectionApiResponse>(id: string,
    patchDataLibraryCollectionRequest: PatchDataLibraryCollectionRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 patchDataLibraryCollection<TData = PatchDataLibraryCollectionApiResponse>(id: string,
    patchDataLibraryCollectionRequest: PatchDataLibraryCollectionRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 patchDataLibraryCollection<TData = PatchDataLibraryCollectionApiResponse>(id: string,
    patchDataLibraryCollectionRequest: PatchDataLibraryCollectionRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  patchDataLibraryCollection<TData = PatchDataLibraryCollectionApiResponse>(
    id: string,
    patchDataLibraryCollectionRequest: PatchDataLibraryCollectionRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/data-library/collections/${id}`,
      patchDataLibraryCollectionRequest,options
    );
  }

/**
 * Returns collection metadata and column definitions for the active workspace.
 * @summary Get a data library collection
 */
 getDataLibraryCollection<TData = GetDataLibraryCollectionApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getDataLibraryCollection<TData = GetDataLibraryCollectionApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getDataLibraryCollection<TData = GetDataLibraryCollectionApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getDataLibraryCollection<TData = GetDataLibraryCollectionApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/data-library/collections/${id}`,options
    );
  }

/**
 * Soft-deletes a collection and its active rows in the active workspace.
 * @summary Delete a data library collection
 */
 deleteDataLibraryCollection<TData = DeleteDataLibraryCollectionApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 deleteDataLibraryCollection<TData = DeleteDataLibraryCollectionApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 deleteDataLibraryCollection<TData = DeleteDataLibraryCollectionApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  deleteDataLibraryCollection<TData = DeleteDataLibraryCollectionApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.delete<TData>(
      `${environment.baseUrl}/data-library/collections/${id}`,options
    );
  }

/**
 * Returns form locations in the active workspace that reference this variable.
 * @summary List usages for a data library variable
 */
 listDataLibraryVariableUsages<TData = ListDataLibraryVariableUsagesApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listDataLibraryVariableUsages<TData = ListDataLibraryVariableUsagesApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listDataLibraryVariableUsages<TData = ListDataLibraryVariableUsagesApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listDataLibraryVariableUsages<TData = ListDataLibraryVariableUsagesApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/data-library/variables/${id}/usages`,options
    );
  }

/**
 * Returns paginated rows for a data library collection in the active workspace. Optional search matches values of the provided searchFields (comma-separated keys).
 * @summary List collection rows
 */
 listDataLibraryCollectionItems<TData = ListDataLibraryCollectionItemsApiResponse>(id: string,
    params?: DeepNonNullable<ListDataLibraryCollectionItemsParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listDataLibraryCollectionItems<TData = ListDataLibraryCollectionItemsApiResponse>(id: string,
    params?: DeepNonNullable<ListDataLibraryCollectionItemsParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listDataLibraryCollectionItems<TData = ListDataLibraryCollectionItemsApiResponse>(id: string,
    params?: DeepNonNullable<ListDataLibraryCollectionItemsParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listDataLibraryCollectionItems<TData = ListDataLibraryCollectionItemsApiResponse>(
    id: string,
    params?: DeepNonNullable<ListDataLibraryCollectionItemsParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/data-library/collections/${id}/items`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a row in a data library collection. The unique field value must be unique among active rows.
 * @summary Add a collection row
 */
 createDataLibraryCollectionItem<TData = CreateDataLibraryCollectionItemApiResponse>(id: string,
    createDataLibraryCollectionItemRequest: CreateDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createDataLibraryCollectionItem<TData = CreateDataLibraryCollectionItemApiResponse>(id: string,
    createDataLibraryCollectionItemRequest: CreateDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createDataLibraryCollectionItem<TData = CreateDataLibraryCollectionItemApiResponse>(id: string,
    createDataLibraryCollectionItemRequest: CreateDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createDataLibraryCollectionItem<TData = CreateDataLibraryCollectionItemApiResponse>(
    id: string,
    createDataLibraryCollectionItemRequest: CreateDataLibraryCollectionItemRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/data-library/collections/${id}/items`,
      createDataLibraryCollectionItemRequest,options
    );
  }

/**
 * Returns paginated data library entries for the active workspace, newest updated first. Optional search matches name and key. Optional valueType returns only variables of that type.
 * @summary List data library entries
 */
 listDataLibrary<TData = ListDataLibraryApiResponse>(params?: DeepNonNullable<ListDataLibraryParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listDataLibrary<TData = ListDataLibraryApiResponse>(params?: DeepNonNullable<ListDataLibraryParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listDataLibrary<TData = ListDataLibraryApiResponse>(params?: DeepNonNullable<ListDataLibraryParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listDataLibrary<TData = ListDataLibraryApiResponse>(
    params?: DeepNonNullable<ListDataLibraryParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/data-library`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a workspace-scoped variable (text, number, date, or boolean). Name must be unique within the active workspace.
 * @summary Create a data library variable
 */
 createDataLibraryVariable<TData = CreateDataLibraryVariableApiResponse>(createDataLibraryVariableRequest: CreateDataLibraryVariableRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createDataLibraryVariable<TData = CreateDataLibraryVariableApiResponse>(createDataLibraryVariableRequest: CreateDataLibraryVariableRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createDataLibraryVariable<TData = CreateDataLibraryVariableApiResponse>(createDataLibraryVariableRequest: CreateDataLibraryVariableRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createDataLibraryVariable<TData = CreateDataLibraryVariableApiResponse>(
    createDataLibraryVariableRequest: CreateDataLibraryVariableRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/data-library/variables`,
      createDataLibraryVariableRequest,options
    );
  }

/**
 * Creates a workspace-scoped collection with column definitions. Name must be unique within the active workspace.
 * @summary Create a data library collection
 */
 createDataLibraryCollection<TData = CreateDataLibraryCollectionApiResponse>(createDataLibraryCollectionRequest: CreateDataLibraryCollectionRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createDataLibraryCollection<TData = CreateDataLibraryCollectionApiResponse>(createDataLibraryCollectionRequest: CreateDataLibraryCollectionRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createDataLibraryCollection<TData = CreateDataLibraryCollectionApiResponse>(createDataLibraryCollectionRequest: CreateDataLibraryCollectionRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createDataLibraryCollection<TData = CreateDataLibraryCollectionApiResponse>(
    createDataLibraryCollectionRequest: CreateDataLibraryCollectionRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/data-library/collections`,
      createDataLibraryCollectionRequest,options
    );
  }

/**
 * Partially updates a contact in the active workspace.
 * @summary Update a contact
 */
 patchContact<TData = PatchContactApiResponse>(id: string,
    patchContactRequest: PatchContactRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 patchContact<TData = PatchContactApiResponse>(id: string,
    patchContactRequest: PatchContactRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 patchContact<TData = PatchContactApiResponse>(id: string,
    patchContactRequest: PatchContactRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  patchContact<TData = PatchContactApiResponse>(
    id: string,
    patchContactRequest: PatchContactRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/contacts/${id}`,
      patchContactRequest,options
    );
  }

/**
 * Returns a contact in the active workspace.
 * @summary Get a contact
 */
 getContact<TData = GetContactApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getContact<TData = GetContactApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getContact<TData = GetContactApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getContact<TData = GetContactApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/contacts/${id}`,options
    );
  }

/**
 * Soft-deletes a contact and removes it from all groups in the active workspace.
 * @summary Delete a contact
 */
 deleteContact<TData = DeleteContactApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 deleteContact<TData = DeleteContactApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 deleteContact<TData = DeleteContactApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  deleteContact<TData = DeleteContactApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.delete<TData>(
      `${environment.baseUrl}/contacts/${id}`,options
    );
  }

/**
 * Returns paginated contacts for the active workspace, newest updated first. Optional search matches name and email.
 * @summary List contacts
 */
 listContacts<TData = ListContactsApiResponse>(params?: DeepNonNullable<ListContactsParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listContacts<TData = ListContactsApiResponse>(params?: DeepNonNullable<ListContactsParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listContacts<TData = ListContactsApiResponse>(params?: DeepNonNullable<ListContactsParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listContacts<TData = ListContactsApiResponse>(
    params?: DeepNonNullable<ListContactsParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/contacts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a workspace-scoped contact. Email must be unique within the active workspace.
 * @summary Create a contact
 */
 createContact<TData = CreateContactApiResponse>(createContactRequest: CreateContactRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createContact<TData = CreateContactApiResponse>(createContactRequest: CreateContactRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createContact<TData = CreateContactApiResponse>(createContactRequest: CreateContactRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createContact<TData = CreateContactApiResponse>(
    createContactRequest: CreateContactRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/contacts`,
      createContactRequest,options
    );
  }

/**
 * Creates multiple workspace-scoped contacts in one request. Emails that already exist in the workspace are skipped and returned in existingItems.
 * @summary Bulk create contacts
 */
 createContacts<TData = CreateContactsApiResponse>(createContactsRequest: CreateContactsRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createContacts<TData = CreateContactsApiResponse>(createContactsRequest: CreateContactsRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createContacts<TData = CreateContactsApiResponse>(createContactsRequest: CreateContactsRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createContacts<TData = CreateContactsApiResponse>(
    createContactsRequest: CreateContactsRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/contacts/bulk`,
      createContactsRequest,options
    );
  }

/**
 * Soft-deletes a contact group membership in the active workspace.
 * @summary Remove a contact from a group
 */
 removeContactGroupMember<TData = RemoveContactGroupMemberApiResponse>(id: string,
    contactId: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 removeContactGroupMember<TData = RemoveContactGroupMemberApiResponse>(id: string,
    contactId: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 removeContactGroupMember<TData = RemoveContactGroupMemberApiResponse>(id: string,
    contactId: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  removeContactGroupMember<TData = RemoveContactGroupMemberApiResponse>(
    id: string,
    contactId: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.delete<TData>(
      `${environment.baseUrl}/contact-groups/${id}/members/${contactId}`,options
    );
  }

/**
 * Partially updates a contact group in the active workspace.
 * @summary Update a contact group
 */
 patchContactGroup<TData = PatchContactGroupApiResponse>(id: string,
    patchContactGroupRequest: PatchContactGroupRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 patchContactGroup<TData = PatchContactGroupApiResponse>(id: string,
    patchContactGroupRequest: PatchContactGroupRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 patchContactGroup<TData = PatchContactGroupApiResponse>(id: string,
    patchContactGroupRequest: PatchContactGroupRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  patchContactGroup<TData = PatchContactGroupApiResponse>(
    id: string,
    patchContactGroupRequest: PatchContactGroupRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.patch<TData>(
      `${environment.baseUrl}/contact-groups/${id}`,
      patchContactGroupRequest,options
    );
  }

/**
 * Returns a contact group and its member count for the active workspace.
 * @summary Get a contact group
 */
 getContactGroup<TData = GetContactGroupApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getContactGroup<TData = GetContactGroupApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getContactGroup<TData = GetContactGroupApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getContactGroup<TData = GetContactGroupApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/contact-groups/${id}`,options
    );
  }

/**
 * Soft-deletes a contact group and all of its memberships in the active workspace.
 * @summary Delete a contact group
 */
 deleteContactGroup<TData = DeleteContactGroupApiResponse>(id: string, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 deleteContactGroup<TData = DeleteContactGroupApiResponse>(id: string, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 deleteContactGroup<TData = DeleteContactGroupApiResponse>(id: string, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  deleteContactGroup<TData = DeleteContactGroupApiResponse>(
    id: string, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.delete<TData>(
      `${environment.baseUrl}/contact-groups/${id}`,options
    );
  }

/**
 * Returns paginated contact groups for the active workspace, including member counts.
 * @summary List contact groups
 */
 listContactGroups<TData = ListContactGroupsApiResponse>(params?: DeepNonNullable<ListContactGroupsParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listContactGroups<TData = ListContactGroupsApiResponse>(params?: DeepNonNullable<ListContactGroupsParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listContactGroups<TData = ListContactGroupsApiResponse>(params?: DeepNonNullable<ListContactGroupsParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listContactGroups<TData = ListContactGroupsApiResponse>(
    params?: DeepNonNullable<ListContactGroupsParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/contact-groups`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a workspace-scoped contact group. Name must be unique within the active workspace.
 * @summary Create a contact group
 */
 createContactGroup<TData = CreateContactGroupApiResponse>(createContactGroupRequest: CreateContactGroupRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createContactGroup<TData = CreateContactGroupApiResponse>(createContactGroupRequest: CreateContactGroupRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createContactGroup<TData = CreateContactGroupApiResponse>(createContactGroupRequest: CreateContactGroupRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createContactGroup<TData = CreateContactGroupApiResponse>(
    createContactGroupRequest: CreateContactGroupRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/contact-groups`,
      createContactGroupRequest,options
    );
  }

/**
 * Returns paginated members of a contact group with contact details.
 * @summary List contact group members
 */
 listContactGroupMembers<TData = ListContactGroupMembersApiResponse>(id: string,
    params?: DeepNonNullable<ListContactGroupMembersParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listContactGroupMembers<TData = ListContactGroupMembersApiResponse>(id: string,
    params?: DeepNonNullable<ListContactGroupMembersParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listContactGroupMembers<TData = ListContactGroupMembersApiResponse>(id: string,
    params?: DeepNonNullable<ListContactGroupMembersParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listContactGroupMembers<TData = ListContactGroupMembersApiResponse>(
    id: string,
    params?: DeepNonNullable<ListContactGroupMembersParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/contact-groups/${id}/members`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Adds one or more contacts to a contact group. Existing memberships are skipped.
 * @summary Add contacts to a group
 */
 addContactGroupMembers<TData = AddContactGroupMembersApiResponse>(id: string,
    addContactGroupMembersRequest: AddContactGroupMembersRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 addContactGroupMembers<TData = AddContactGroupMembersApiResponse>(id: string,
    addContactGroupMembersRequest: AddContactGroupMembersRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 addContactGroupMembers<TData = AddContactGroupMembersApiResponse>(id: string,
    addContactGroupMembersRequest: AddContactGroupMembersRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  addContactGroupMembers<TData = AddContactGroupMembersApiResponse>(
    id: string,
    addContactGroupMembersRequest: AddContactGroupMembersRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/contact-groups/${id}/members`,
      addContactGroupMembersRequest,options
    );
  }

/**
 * Creates a company for the authenticated user, provisions a subscription and usage counter on the company, creates the first workspace with the provided name, and returns tokens scoped to that workspace.
 * @summary Create a company
 */
 createCompany<TData = CreateCompanyApiResponse>(createCompanyRequest: CreateCompanyRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 createCompany<TData = CreateCompanyApiResponse>(createCompanyRequest: CreateCompanyRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 createCompany<TData = CreateCompanyApiResponse>(createCompanyRequest: CreateCompanyRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  createCompany<TData = CreateCompanyApiResponse>(
    createCompanyRequest: CreateCompanyRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/companies`,
      createCompanyRequest,options
    );
  }

/**
 * Creates a new user account with local credentials, provisions a default workspace with OWNER role, and returns access and refresh tokens.
 * @summary Sign up with email and password
 */
 signupLocal<TData = SignupLocalApiResponse>(signupLocalRequest: SignupLocalRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 signupLocal<TData = SignupLocalApiResponse>(signupLocalRequest: SignupLocalRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 signupLocal<TData = SignupLocalApiResponse>(signupLocalRequest: SignupLocalRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  signupLocal<TData = SignupLocalApiResponse>(
    signupLocalRequest: SignupLocalRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/auth/signup/local`,
      signupLocalRequest,options
    );
  }

/**
 * Deprecated. Use GET /auth/google and POST /auth/exchange-ticket instead.
 * @summary Sign up or sign in with Google (deprecated)
 */
 signupGoogle<TData = unknown>(signupGoogleRequest: SignupGoogleRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 signupGoogle<TData = unknown>(signupGoogleRequest: SignupGoogleRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 signupGoogle<TData = unknown>(signupGoogleRequest: SignupGoogleRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  signupGoogle<TData = unknown>(
    signupGoogleRequest: SignupGoogleRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/auth/signup/google`,
      signupGoogleRequest,options
    );
  }

/**
 * Authenticates a user with local credentials and returns access and refresh tokens.
 * @summary Sign in with email and password
 */
 loginLocal<TData = LoginLocalApiResponse>(loginLocalRequest: LoginLocalRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 loginLocal<TData = LoginLocalApiResponse>(loginLocalRequest: LoginLocalRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 loginLocal<TData = LoginLocalApiResponse>(loginLocalRequest: LoginLocalRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  loginLocal<TData = LoginLocalApiResponse>(
    loginLocalRequest: LoginLocalRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/auth/login/local`,
      loginLocalRequest,options
    );
  }

/**
 * Starts Google OAuth flow, persists context in an OAuthTransaction, and redirects the browser to Google.
 * @summary Redirect to Google OAuth login
 */
 redirectToGoogleAuth<TData = unknown>(params: DeepNonNullable<RedirectToGoogleAuthParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 redirectToGoogleAuth<TData = unknown>(params: DeepNonNullable<RedirectToGoogleAuthParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 redirectToGoogleAuth<TData = unknown>(params: DeepNonNullable<RedirectToGoogleAuthParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  redirectToGoogleAuth<TData = unknown>(
    params: DeepNonNullable<RedirectToGoogleAuthParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/auth/google`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Handles the Google OAuth redirect, validates state, resolves the user or My Forms respondent, and redirects to the frontend success page with a login ticket.
 * @summary Google OAuth callback
 */
 handleGoogleOAuthCallback<TData = unknown>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 handleGoogleOAuthCallback<TData = unknown>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 handleGoogleOAuthCallback<TData = unknown>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  handleGoogleOAuthCallback<TData = unknown>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/auth/google/callback`,options
    );
  }

/**
 * Consumes a one-time login ticket issued after Google OAuth and returns access and refresh tokens plus OAuth context.
 * @summary Exchange login ticket for session tokens
 */
 exchangeTicket<TData = ExchangeTicketApiResponse>(exchangeTicketRequest: ExchangeTicketRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 exchangeTicket<TData = ExchangeTicketApiResponse>(exchangeTicketRequest: ExchangeTicketRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 exchangeTicket<TData = ExchangeTicketApiResponse>(exchangeTicketRequest: ExchangeTicketRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  exchangeTicket<TData = ExchangeTicketApiResponse>(
    exchangeTicketRequest: ExchangeTicketRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/auth/exchange-ticket`,
      exchangeTicketRequest,options
    );
  }

};

export type SwitchWorkspaceClientResult = NonNullable<SwitchWorkspaceApiResponse>
export type UpdateOnboardingTeamSizeClientResult = NonNullable<OnboardingSurveyApiResponse>
export type UpdateOnboardingPlannedUseCasesClientResult = NonNullable<OnboardingSurveyApiResponse>
export type UpdateOnboardingIndustryClientResult = NonNullable<OnboardingSurveyApiResponse>
export type UpdateOnboardingHeardAboutClientResult = NonNullable<OnboardingSurveyApiResponse>
export type SkipOnboardingSurveyClientResult = NonNullable<OnboardingSurveyApiResponse>
export type ListMyWorkspacesClientResult = NonNullable<ListMyWorkspacesApiResponse>
export type PreviewWorkspaceInvitationClientResult = NonNullable<PreviewWorkspaceInvitationApiResponse>
export type ListWorkspaceMembersClientResult = NonNullable<ListWorkspaceMembersApiResponse>
export type ListWorkspaceInvitationsClientResult = NonNullable<ListWorkspaceInvitationsApiResponse>
export type CreateWorkspaceInvitationsClientResult = NonNullable<CreateWorkspaceInvitationsApiResponse>
export type AcceptWorkspaceInvitationClientResult = NonNullable<AcceptWorkspaceInvitationApiResponse>
export type CreateWorkspaceClientResult = NonNullable<CreateWorkspaceApiResponse>
export type CheckWorkspaceSlugAvailabilityClientResult = NonNullable<CheckWorkspaceSlugApiResponse>
export type ListSystemVariablesClientResult = NonNullable<ListSystemVariablesApiResponse>
export type StartSubscriptionTrialClientResult = NonNullable<StartTrialApiResponse>
export type ConfirmSubscriptionPaymentClientResult = NonNullable<ConfirmPaymentApiResponse>
export type UnlockPublicFormClientResult = NonNullable<UnlockPublicFormApiResponse>
export type ResolveFormShortLinkClientResult = NonNullable<unknown>
export type ResolvePublicFormClientResult = NonNullable<ResolvePublicFormApiResponse>
export type GetPublicFormDraftClientResult = NonNullable<GetPublicFormDraftApiResponse>
export type PutPublicFormDraftClientResult = NonNullable<PutPublicFormDraftApiResponse>
export type CreatePublicFormSubmissionClientResult = NonNullable<CreatePublicFormSubmissionApiResponse>
export type ListPublicFormFieldOptionsClientResult = NonNullable<PublicFieldOptionsApiResponse>
export type GetAvailablePlansClientResult = NonNullable<GetAvailablePlansApiResponse>
export type SaveFormDefinitionClientResult = NonNullable<SaveFormDefinitionApiResponse>
export type PublishFormClientResult = NonNullable<PublishFormApiResponse>
export type ListFormsClientResult = NonNullable<ListFormsApiResponse>
export type CreateFormClientResult = NonNullable<CreateFormApiResponse>
export type GetFormDetailsClientResult = NonNullable<GetFormApiResponse>
export type CheckFormSlugAvailabilityClientResult = NonNullable<CheckFormSlugApiResponse>
export type GenerateFormWithAiClientResult = NonNullable<AiGenerateApiResponse>
export type PatchDataLibraryVariableClientResult = NonNullable<PatchDataLibraryVariableApiResponse>
export type DeleteDataLibraryVariableClientResult = NonNullable<DeleteDataLibraryVariableApiResponse>
export type PatchDataLibraryCollectionItemClientResult = NonNullable<PatchDataLibraryCollectionItemApiResponse>
export type DeleteDataLibraryCollectionItemClientResult = NonNullable<DeleteDataLibraryCollectionItemApiResponse>
export type PatchDataLibraryCollectionClientResult = NonNullable<PatchDataLibraryCollectionApiResponse>
export type GetDataLibraryCollectionClientResult = NonNullable<GetDataLibraryCollectionApiResponse>
export type DeleteDataLibraryCollectionClientResult = NonNullable<DeleteDataLibraryCollectionApiResponse>
export type ListDataLibraryVariableUsagesClientResult = NonNullable<ListDataLibraryVariableUsagesApiResponse>
export type ListDataLibraryCollectionItemsClientResult = NonNullable<ListDataLibraryCollectionItemsApiResponse>
export type CreateDataLibraryCollectionItemClientResult = NonNullable<CreateDataLibraryCollectionItemApiResponse>
export type ListDataLibraryClientResult = NonNullable<ListDataLibraryApiResponse>
export type CreateDataLibraryVariableClientResult = NonNullable<CreateDataLibraryVariableApiResponse>
export type CreateDataLibraryCollectionClientResult = NonNullable<CreateDataLibraryCollectionApiResponse>
export type PatchContactClientResult = NonNullable<PatchContactApiResponse>
export type GetContactClientResult = NonNullable<GetContactApiResponse>
export type DeleteContactClientResult = NonNullable<DeleteContactApiResponse>
export type ListContactsClientResult = NonNullable<ListContactsApiResponse>
export type CreateContactClientResult = NonNullable<CreateContactApiResponse>
export type CreateContactsClientResult = NonNullable<CreateContactsApiResponse>
export type RemoveContactGroupMemberClientResult = NonNullable<RemoveContactGroupMemberApiResponse>
export type PatchContactGroupClientResult = NonNullable<PatchContactGroupApiResponse>
export type GetContactGroupClientResult = NonNullable<GetContactGroupApiResponse>
export type DeleteContactGroupClientResult = NonNullable<DeleteContactGroupApiResponse>
export type ListContactGroupsClientResult = NonNullable<ListContactGroupsApiResponse>
export type CreateContactGroupClientResult = NonNullable<CreateContactGroupApiResponse>
export type ListContactGroupMembersClientResult = NonNullable<ListContactGroupMembersApiResponse>
export type AddContactGroupMembersClientResult = NonNullable<AddContactGroupMembersApiResponse>
export type CreateCompanyClientResult = NonNullable<CreateCompanyApiResponse>
export type SignupLocalClientResult = NonNullable<SignupLocalApiResponse>
export type SignupGoogleClientResult = NonNullable<unknown>
export type LoginLocalClientResult = NonNullable<LoginLocalApiResponse>
export type RedirectToGoogleAuthClientResult = NonNullable<unknown>
export type HandleGoogleOAuthCallbackClientResult = NonNullable<unknown>
export type ExchangeTicketClientResult = NonNullable<ExchangeTicketApiResponse>
